<template>
  <tr class="integration-failed-attempts-list-item">
    <td>
      {{ registerDate }}
    </td>

    <td>
      {{ item.localName }}
    </td>

    <td>
      <button class="view-content-button">
        <i
          v-tooltip="$t('message.integrations.message.viewContent')"
          class="mdi mdi-eye-outline"
          slot="activator"
          @click="handleMessageModalOpening('content')"
        ></i>
      </button>
    </td>

    <td>
      <button class="view-error-button">
        <i
          v-tooltip="$t('message.integrations.message.viewError')"
          class="mdi mdi-alert-circle-outline"
          slot="activator"
          @click="handleMessageModalOpening('error')"
        ></i>
      </button>
    </td>

    <IntegrationFailedAttemptsListItemMessageModal
      v-if="showMessageModal"
      v-model="showMessageModal"
      :type="messageModalType"
      :data="messageModalData"
    />
  </tr>
</template>

<script>
import IntegrationFailedAttemptsListItemMessageModal from "./message-modal/IntegrationFailedAttemptsListItemMessageModal.vue";

export default {
  components: {
    IntegrationFailedAttemptsListItemMessageModal,
  },

  data() {
    return {
      showMessageModal: false,
      messageModalType: undefined,
    };
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    registerDate() {
      return this.$date.format(this.item.registerDate);
    },
    messageModalData() {
      return this.messageModalType === "content"
        ? this.item.content
        : this.item.causeError;
    },
  },

  methods: {
    handleMessageModalOpening(type) {
      this.messageModalType = type;
      this.showMessageModal = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.integration-failed-attempts-list-item {
  .view-content-button {
    margin-left: 24px;
  }

  .view-error-button {
    margin-left: 8px;
  }
}
</style>
